<template>
  <shop-search
    starting-index="products:product__random:asc"
    :show-buy-it-now="false"
    :show-collections="true"
    :default-refinement="[{ facet: 'product__collections__names', value: 'Our Favorites' }]"
    :featured-products="featuredProducts"
  />
</template>

<script>
import StorefrontLayout from "@/layout/storefront-layout.vue";
import "@styles/shop/shop.scss";

// Not async: it is the whole page, which otherwise renders empty until its chunk arrives.
import ShopSearch from "@/shop/shop-search.vue";

export default {
  name: "Shop",
  layout: StorefrontLayout,
  components: { ShopSearch },
  props: {
    featuredProducts: { type: Array, default: () => [] },
  },
};
</script>
